<template>
  <div>
    <div class="row">
      <div class="col-xs-20">
        <label>
          {{ label }}
        </label>
      </div>

      <div class="col-xs-4">
        <button type="button" class="btn btn-block btn-white" @click="add">
          <i class="fa fa-plus"/> Add
        </button>
      </div>
    </div>

    <div v-for="(row, index) in value">
      <div class="row" :class="{'tw-mt-4': index !== 0}">
        <div class="col-xs-20">
          <slot :data="row" :index="index" :change="change" :errors="getErrors(index)"/>
        </div>

        <div class="col-xs-4">
          <button type="button" class="btn btn-block btn-white" @click="remove(index)">
            <i class="fa fa-minus"/> Remove
          </button>
        </div>
      </div>
    </div>

    <div v-if="value.length === 0">
      <i>
        {{ emptyText }}
      </i>
    </div>

    <button type="button" class="btn btn-block btn-white" @click="add">
      <i class="fa fa-plus"/> Add
    </button>

    <span v-if="helpText" class="help-block">
        {{ helpText }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: true
    },

    helpText: {
      required: false,
      type: String
    },

    emptyText: {
      required: false,
      type: String,
      default: 'There are no rows in the value.'
    },

    value: {
      required: false,
      type: Array,
      default: () => ([])
    },

    errors: {
      required: true,
      type: Object
    },

    emptyRow: {
      required: false,
      type: Function,
      default: () => ({})
    }
  },

  methods: {
    add() {
      let data = [...this.value]

      data.push(this.emptyRow())

      this.$emit('input', data)
    },

    change(index, key, value = null) {
      let data = [...this.value]

      if(value) {
        data[index] = {...data[index], [key]: value}
      } else {
        data[index] = {...data[index], ...key}
      }

      this.$emit('input', data)
    },

    remove(index) {
      let data = [...this.value]

      data.splice(index, 1)

      this.$emit('input', data)
    },

    getErrors(index) {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith(index+'.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring((index+'.').length)]: entry[1]
          }), {})
    }
  }
}
</script>